module.exports = __webpack_public_path__ + "img/process_3.8673e4e6.svg";